import path from "path";

import { WellKnownDirectories } from "./WellKnownDirectories";

export class WellKnownDirectoryPaths {
    public static ReposRoot = path.join(__dirname, "..", "..");

    public static ExternFarm = path.join(
        WellKnownDirectoryPaths.ReposRoot,
        WellKnownDirectories.ExternFormsDefaultCheckoutDirectory
    );
    public static DiadocFarm = path.join(
        WellKnownDirectoryPaths.ReposRoot,
        WellKnownDirectories.DiadocFormsDefaultCheckoutDirectory
    );
    public static RpnFarm = path.join(
        WellKnownDirectoryPaths.ReposRoot,
        WellKnownDirectories.RpnFormsDefaultCheckoutDirectory
    );

    public static ExternForms = path.join(WellKnownDirectoryPaths.ExternFarm, WellKnownDirectories.FormsDirectory);
    public static DiadocForms = path.join(WellKnownDirectoryPaths.DiadocFarm, WellKnownDirectories.FormsDirectory);
    public static RpnForms = path.join(WellKnownDirectoryPaths.RpnFarm, WellKnownDirectories.FormsDirectory);
}
